import React from 'react';
import styled from 'styled-components';
import { useBasket } from './BasketContext';
import { usePricing } from './PricingContext';
import { useNavigate } from 'react-router-dom';

const CardContainer = styled.div`
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  display: flex;
  height: 100%; /* Make card take full height of its container */
  flex-direction: column;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12);
  }
`;

const ProductImage = styled.img`
  width: 100%;
  height: 180px;
  object-fit: cover;
`;

const ProductInfo = styled.div`
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

const ProductName = styled.h3`
  font-size: 1.2rem;
  margin: 0 0 0.5rem 0;
  color: #333;
`;

const PriceRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
  margin: 0 0 1rem 0;
`;

const ProductPrice = styled.p`
  font-size: 1.25rem;
  font-weight: bold;
  color: #005eb8;
  margin: 0;
`;

const OriginalPrice = styled.span`
  font-size: 1rem;
  color: #999;
  text-decoration: line-through;
`;

const ProductDescription = styled.p`
  font-size: 0.95rem;
  color: #666;
  line-height: 1.5;
  flex-grow: 1;
  margin-bottom: 1.5rem;
`;

const AddToBasketButton = styled.button`
  background-color: #005eb8;
  color: white;
  border: none;
  padding: 0.75rem 1rem;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  text-decoration: none;
  transition: background-color 0.2s;
  margin-top: auto;

  &:hover {
    background-color: #004a94;
  }
`;

const ProductCard = ({ service }) => {
  const { addToBasket } = useBasket();
  const { getPricedService } = usePricing();
  const navigate = useNavigate();

  const pricedService = getPricedService(service);
  const hasDiscount = pricedService.discountPercent > 0;

  const handleAddToBasket = () => {
    addToBasket(pricedService);
    navigate('/basket');
  };

  return (
    <CardContainer>
      <ProductImage src={service.image} alt={service.name} />
      <ProductInfo>
        <ProductName>{service.name}</ProductName>
        <PriceRow>
          {hasDiscount && <OriginalPrice>£{pricedService.originalPrice.toFixed(2)}</OriginalPrice>}
          <ProductPrice>£{pricedService.price.toFixed(2)}</ProductPrice>
        </PriceRow>
        <ProductDescription>{service.description}</ProductDescription>
        <AddToBasketButton onClick={handleAddToBasket}>
          Add to Basket
        </AddToBasketButton>
      </ProductInfo>
    </CardContainer>
  );
};

export default ProductCard;